// taken from https://github.com/rstudio/package-manager/blob/d892d45664a4be0faf98a386e3bc6c38d48ca8a6/src/rspm/store/source/types.go#L21-L30
// const (
// Local        = SourceType(0)
// CRAN         = SourceType(1)
// CuratedCRAN  = SourceType(2)
// Git          = SourceType(3)
// PyPI         = SourceType(4)
// BiocInternal = SourceType(5)
// CRANSnapshot = SourceType(6)
// Bioconductor = SourceType(7)
// )
const CRANSourceTypes = [5, 7]

export function isCranSource (currentRepoSources) {
  if (currentRepoSources === undefined || currentRepoSources.length === 0) {
    return false
  }
  return (currentRepoSources.length === 1 && currentRepoSources[0].type === 1) || (
    CRANSourceTypes.includes(currentRepoSources[0].type))
}
